import PropTypes from 'prop-types';
import classes from './HTMLFormatter.module.scss';
import "./ql-editor.css";
import clsx from 'clsx';

export default function HTMLFormatter({ html, className }) {
    return (
        <div
            className={clsx(classes.formatter, className)}
            dangerouslySetInnerHTML={{ __html: html }}
        />
    )
}

HTMLFormatter.propTypes = {
    html: PropTypes.string,
    className: PropTypes.string
}